// extracted by mini-css-extract-plugin
export default {"container":"GlobalAlertBar_container__iwfZM","slideDown":"GlobalAlertBar_slideDown__vVAsN","close":"GlobalAlertBar_close__S-tVD"};